/* Hero video: nạp SAU khi trang đã dựng xong, không tranh băng thông lúc đầu.
 *
 * VÌ SAO. Đo bằng HAR của GTmetrix: trang chủ tải 8,82MB trong cửa sổ trước
 * `onLoad`, trong đó riêng video là 7,19MB. Hero một mình ~5MB — tức khoảng ba
 * phần tư trọng lượng của cả cửa sổ dựng trang.
 *
 * Thứ đáng nói: 5MB đó KHÔNG quyết định khách nhìn thấy gì trước. Ảnh `poster`
 * của hero tải xong ở mốc 222ms, còn video mới bắt đầu ở 509ms — poster mới là
 * thứ vẽ ra màn hình đầu tiên. Video chỉ giành băng thông với CSS, font và ảnh
 * trong lúc trang đang dựng.
 *
 * Nên tách hai việc: poster vẽ ngay như cũ, video nạp sau khi `load` đã bắn.
 * Autoplay giữ nguyên — gán `src` xong là trình duyệt tự phát, vì thuộc tính
 * `autoplay` vẫn nằm trên thẻ.
 *
 * KHÔNG DÙNG `preload="none"` CHO HERO. Với `autoplay`, trình duyệt bỏ qua
 * `preload` và vẫn tải để phát. Cách duy nhất hoãn được là ĐỪNG cho nó `src`
 * ngay từ đầu — đó là việc file này làm.
 *
 * HỎNG THÌ HỎNG AN TOÀN: JS lỗi hoặc bị chặn -> hero đứng ở ảnh poster, vẫn là
 * hình đúng của trang, chỉ mất chuyển động. Không có khoảng đen, không vỡ bố cục.
 *
 * Có hẹn giờ dự phòng 4 giây: vài trình duyệt trong webview (ví dụ trình duyệt
 * trong ứng dụng Facebook — kênh vào chính của store này) đôi khi không bắn
 * `load` như mong đợi. Cái nào tới trước thì chạy.
 */
(function () {
  'use strict';

  var GOC = '.lb-demo .hero__video[data-src]';

  function nap() {
    var vs = document.querySelectorAll(GOC);
    Array.prototype.forEach.call(vs, function (v) {
      var u = v.getAttribute('data-src');
      if (!u || v.src) return;                 // đã nạp rồi thì thôi
      v.removeAttribute('data-src');           // chặn lần gọi thứ hai
      v.src = u;
      // `autoplay` lo phần phát. Gọi thêm play() cho chắc, và nuốt lỗi: trình
      // duyệt nào chặn phát tự động thì poster vẫn đang hiện, không mất gì.
      var hua = v.play();
      if (hua && hua.catch) hua.catch(function () {});
    });
  }

  var xong = false;
  function chay() { if (xong) return; xong = true; nap(); }

  if (document.readyState === 'complete') {
    chay();
  } else {
    window.addEventListener('load', chay);
    setTimeout(chay, 4000);                    // dự phòng cho webview
  }
})();
